/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../css/login.css';
import PropTypes from 'prop-types';

class ForgotPassword extends React.Component {
    render() {
        const {label, onClickFunction} = this.props;
        return (
            <div onClick={onClickFunction} className="op-link">{label}</div>
        );
    }
}

ForgotPassword.promptTypes = {
    label: PropTypes.string,
    onClickFunction: PropTypes.func
};


export default ForgotPassword;
